<template>
    <div id="form-four" class="form">
       <transition name="fade">
           <pop-agreement :close="closePop" :popAgreementValue="popAgreementValue" v-if="popUpToggle"></pop-agreement>
       </transition>
        <fieldset>
            <legend>介紹人轉介</legend>
            <div class="one-line">
               <input type="text" placeholder="如經介紹人介紹開戶，請在此填寫介紹人號碼" v-validate="{ numeric: true, max: 50, min: 3 }" name="Client[client_broker_id]" data-vv-as="介紹人號碼" v-model="client_broker_id" data-vv-name="client_broker_id">
               <span :class="{'invalid': errors.has('signup_agent_form.client_broker_id'), 'valid': !errors.has('signup_agent_form.client_broker_id')}">{{errors.first('signup_agent_form.client_broker_id')}}<span v-if="(!errors.has('signup_agent_form.client_broker_id') && client_broker_id.length > 0)">介紹人號碼</span></span>
           </div>
        </fieldset>
        <fieldset>
            <legend>條款及協議合同</legend>
            <div class="remind">
                請務必同意以下條款、協議、聲明、細則等。<br>
                中文譯本僅供參考，文意如與英文本有歧異，概以英文本為準。<br>
                請細閱客戶協議及其他有關文件並確保完全明白其全部內容。如有需要，請諮詢獨立專業顧問的意見。<br>
                直接點擊下方條款及條文，即可細閱其條文。
            </div>
            <div class="one-line">
               <span style="white-space: normal">本人清楚閱讀和了解，並同意<span class="agreement-btn" @click="popAgreement('ntc')">《容戶告鑒及客戶協議》</span>。</span>
               <input type="checkbox" id="agreement-1" name="Client[client_agreement_ntc]" v-model="client_agreement_ntc" v-validate="{agreement: true}" data-vv-as="《容戶告鑒及客戶協議》">
               <label for="agreement-1"></label>
               <span class="invalid" v-if="client_agreement_ntc === false">{{errors.first('signup_agent_form.Client[client_agreement_ntc]')}}</span>
           </div>
           <div class="one-line">
               <span style="white-space: normal">本人清楚閱讀和了解，並同意<span class="agreement-btn" @click="popAgreement('rds')">《風險披露聲明》</span>。</span>
               <input type="checkbox" id="agreement-2" name="Client[client_agreement_rds]" v-model="client_agreement_rds" v-validate="{agreement: true}" data-vv-as="《風險披露聲明》">
               <label for="agreement-2"></label>
               <span class="invalid" v-if="client_agreement_rds === false">{{errors.first('signup_agent_form.Client[client_agreement_rds]')}}</span>
           </div>
           <div class="one-line">
               <span style="white-space: normal">本人清楚閱讀和了解，並同意<span class="agreement-btn" @click="popAgreement('ggtrar')">《通用導則與交易規則》</span>。</span>
               <input type="checkbox" id="agreement-3" name="Client[client_agreement_ggtrar]" v-model="client_agreement_ggtrar" v-validate="{agreement: true}" data-vv-as="《通用導則與交易規則》">
               <label for="agreement-3"></label>
               <span class="invalid" v-if="client_agreement_ggtrar === false">{{errors.first('signup_agent_form.Client[client_agreement_ggtrar]')}}</span>
           </div>
        </fieldset>
        <fieldset>
            <legend>重要聲明</legend>
            <div class="one-line">
               <span style="white-space: normal">本人聲明帳戶將由本人自行管理並對帳戶內的盈虧負上所有責任。</span>
               <input type="checkbox" id="agreement-4" name="Client[client_agreement_declare]" v-model="client_agreement_declare" v-validate="{agreement: true}" data-vv-as="以下聲明">
               <label for="agreement-4"></label>
               <span class="invalid" v-if="client_agreement_declare === false">{{errors.first('signup_agent_form.Client[client_agreement_declare]')}}</span>
           </div>
        </fieldset>
    </div>
</template>

<script>
    import popAgreement from "./popAgreement.vue";
    export default {
        inherit: true,
        inject: ['$validator'],
        name: "formFour",
        components: {
            "pop-agreement": popAgreement
        },
        data: () => ({
            /* pop Up Agreement */
            popAgreementValue: "",
            popUpToggle: false,
            /* v-model below, form core */
            client_broker_id: "",
            client_agreement_ntc: false,
            client_agreement_rds: false,
            client_agreement_ggtrar: false,
            client_agreement_declare: false
        }),
        created: function(){
            this.$validator.localize({
                zh_TW: {
                    custom:{
                        client_broker_id:{
                            numeric: (field) => "請填寫有效的" + field + "，如不適用請留空",
                            max: (field) => "請填寫有效的" + field + "，如不適用請留空",
                            min: (field) => "請填寫有效的" + field + "，如不適用請留空",
                        }
                    }
                }
            });
        },
        methods: {
            popAgreement(agreementName){
                this.popAgreementValue = agreementName;
                this.popUpToggle = !this.popUpToggle;
            },
            closePop(){
                this.popUpToggle = false;
            }
        }
    }
</script>

<style>

</style>
